import moment from 'moment';

/**
 * Converts time to HH:mm format
 * @param time - Time string in format HH:mm:ss, HH:mm, H:m, H:mm, HH:m
 */
export default (time: string | null | undefined): string | undefined  => {
  if (!time) return undefined;

  const m = moment(time, ['HH:mm:ss', 'HH:mm', 'H:m', 'H:mm', 'HH:m'], true);

  if (!m.isValid()) return undefined;

  return m.format('HH:mm');
}
